import { render } from "./DDTermOfUse.vue?vue&type=template&id=59a6a939"
import script from "./DDTermOfUse.vue?vue&type=script&lang=js"
export * from "./DDTermOfUse.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__